import { Radio, Map, DollarSign, FileText, Building2, Bell, BarChart, Plug, CheckCircle2 } from "lucide-react";

const ITEMS = [
  { Icon: Radio, title: "811 / One-Call Feeds", ex: "Utilisphere, state portals, direct feeds" },
  { Icon: Map, title: "GIS & Mapping", ex: "Esri, Google Maps, custom layers" },
  { Icon: DollarSign, title: "Payroll & Timecards", ex: "ADP, Paycom, custom exports" },
  { Icon: FileText, title: "Accounting & Billing", ex: "QuickBooks, custom invoicing" },
  { Icon: Building2, title: "Customer Portals", ex: "Client-specific reporting and access" },
  { Icon: Bell, title: "Alerts & Notifications", ex: "Email, SMS, push notifications" },
  { Icon: BarChart, title: "Analytics & BI", ex: "Power BI, Tableau, CSV export" },
  { Icon: Plug, title: "API & Webhooks", ex: "REST API, webhooks, CSV import" },
];

const COMPAT_CHIPS = [
  "All state one-call centers",
  "Direct ticket feed ingestion",
  "Utilisphere compatible",
  "Auto-classify on import",
];

export default function Integrations() {
  return (
    <section data-testid="integrations-section" className="section-y relative">
      <div className="container-x">
        <div className="max-w-3xl reveal mb-12">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">Integrations</div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
            Connect LocateOS to the systems your team already uses.
          </h2>
        </div>

        {/* 811 Compatibility featured card */}
        <div
          data-testid="integrations-811-card"
          className="reveal mb-6 rounded-2xl glass-strong border border-white/10 border-l-4 border-l-[#22C55E] p-6 md:p-8 relative overflow-hidden"
          style={{ boxShadow: "0 0 40px rgba(34,197,94,0.08)" }}
        >
          <div className="absolute -top-20 -right-10 w-72 h-72 rounded-full bg-[#22C55E]/15 blur-3xl pointer-events-none" />
          <div className="relative">
            <div className="inline-flex items-center gap-2 rounded-full bg-[#22C55E]/15 border border-[#22C55E]/30 px-3 py-1 mb-4">
              <span className="h-1.5 w-1.5 rounded-full bg-[#22C55E] pulse-dot" />
              <span className="text-[10px] font-mono uppercase tracking-widest text-[#22C55E]">811 Ready</span>
            </div>
            <h3 className="font-display font-extrabold text-2xl sm:text-3xl text-white tracking-tight max-w-3xl">
              Fully Compatible with 811 & One-Call Systems
            </h3>
            <p className="mt-3 text-[#94A3B8] leading-relaxed max-w-3xl">
              LocateOS connects directly to state 811 one-call centers and ticket feed providers — so every ticket that comes in gets captured, classified, and dispatched automatically.
            </p>

            <div className="mt-6 flex flex-wrap gap-2.5">
              {COMPAT_CHIPS.map((c) => (
                <span
                  key={c}
                  className="inline-flex items-center gap-2 rounded-full bg-[#22C55E]/10 border border-[#22C55E]/30 px-3.5 py-1.5 text-sm text-white"
                >
                  <CheckCircle2 size={14} className="text-[#22C55E]" />
                  {c}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {ITEMS.map(({ Icon, title, ex }, i) => (
            <div
              key={title}
              className="reveal group rounded-2xl glass p-5 hover:-translate-y-1 hover:border-[#FB923C]/40 transition-all"
              style={{ transitionDelay: `${(i % 4) * 60}ms` }}
            >
              <div className="h-11 w-11 rounded-xl bg-[#FB923C]/15 border border-[#FB923C]/30 grid place-items-center mb-4">
                <Icon size={18} className="text-[#FDBA74]" />
              </div>
              <div className="font-display font-bold text-white mb-1">{title}</div>
              <div className="text-sm text-[#94A3B8]">{ex}</div>
            </div>
          ))}
        </div>

        <p className="reveal mt-6 text-sm text-[#94A3B8] text-center">
          Early deployment supported via CSV import/export. API documentation available on request.
        </p>
      </div>
    </section>
  );
}
